import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/insider-up.svg";
var InsiderUpOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  InsiderUpOutline_default as default
};
